import { EditPencil } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconEditPencil12Line = createIcon(EditPencil, 12, "Line");
export const IconEditPencil16Line = createIcon(EditPencil, 16, "Line");
export const IconEditPencil20Line = createIcon(EditPencil, 20, "Line");
export const IconEditPencil24Line = createIcon(EditPencil, 24, "Line");
export const IconEditPencil32Line = createIcon(EditPencil, 32, "Line");
export const IconEditPencil48Line = createIcon(EditPencil, 48, "Line");
export const IconEditPencil64Line = createIcon(EditPencil, 64, "Line");
